import { render, staticRenderFns } from "./report-table.vue?vue&type=template&id=63e222f1&scoped=true"
import script from "./report-table.vue?vue&type=script&lang=js"
export * from "./report-table.vue?vue&type=script&lang=js"
import style0 from "./report-table.vue?vue&type=style&index=0&id=63e222f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e222f1",
  null
  
)

export default component.exports